import config from '../config.json'
import axios from 'axios';

class apiHelper {
    constructor() {
        this.apiBaseUrl = config.apiBaseUrl;
    }
    async GetMeetingSections(){
        try {
            const response = await axios.get(`${this.apiBaseUrl}/Meetings`);
            return response.data;
        } catch (error) {
            console.error('Error fetching meetings:', error);
            throw error;
        }
    }
    async GetDocumentSections(){
        try {
            const response = await axios.get(`${this.apiBaseUrl}/Documents`);
            return response.data;
        } catch (error) {
            console.error('Error fetching documents:', error);
            throw error;
        }
    }
    async GetHomepageContent(){
        try {
            const response = await axios.get(`${this.apiBaseUrl}/Homepage`);
            return response.data;
        } catch (error) {
            console.error('Error fetching homepage content:', error);
            throw error;
        }
    }
}
export default apiHelper; 